export const addressPOBoxErrorCodes = [
  'AS17',
  'AS11',
  'AS20',
  'AS10',
  'AS16',
  'AS24',
]
